import axios from 'axios'
export default {
  methods: {
    rec_registraduria_ciudad (pciudadId) {
      this.loadingRegistraduria = true
      this.items_registradurias = []
      var urlroute = this.$store.getters.getUrl + 'registradurias_ciudad/' + pciudadId
      axios({
        url: urlroute,
        method: 'GET',
        data: null,
        auth: {
          username: this.$store.getters.getHeadUsuario,
          password: this.$store.getters.getHeadPassword
        }
      }).then(response => {
        this.items_registradurias = response.data
      }).catch(error => {
        console.log('error ' + error)
      }).finally(() => {
        this.loadingRegistraduria = false
      })
    },
    rec_registraduria_id (pId) {
      this.registrador.direccion = ''
      this.loadingRegistraduria = true
      var urlroute = this.$store.getters.getUrl + 'registradurias_ids/' + pId
      axios({
        url: urlroute,
        method: 'GET',
        data: null,
        auth: {
          username: this.$store.getters.getHeadUsuario,
          password: this.$store.getters.getHeadPassword
        }
      }).then(response => {
        const data = response.data
        this.registrador.direccion = data.direccion
      }).catch(error => {
        console.log('error ' + error)
      }).finally(() => {
        this.loadingRegistraduria = false
      })
    }

  }
}
